/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppPublishRouteImport } from './routes/_app/publish'
import { Route as AppTailRouteImport } from './routes/_app/tail'
import { Route as AppCatalogIndexRouteImport } from './routes/_app/catalog/index'
import { Route as AppCatalogStreamRouteImport } from './routes/_app/catalog/$stream'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppPublishRoute = AppPublishRouteImport.update({
  id: '/publish',
  path: '/publish',
  getParentRoute: () => AppRoute,
} as any)
const AppTailRoute = AppTailRouteImport.update({
  id: '/tail',
  path: '/tail',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogIndexRoute = AppCatalogIndexRouteImport.update({
  id: '/catalog/',
  path: '/catalog/',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogStreamRoute = AppCatalogStreamRouteImport.update({
  id: '/catalog/$stream',
  path: '/catalog/$stream',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/publish': typeof AppPublishRoute
  '/tail': typeof AppTailRoute
  '/catalog/$stream': typeof AppCatalogStreamRoute
  '/catalog/': typeof AppCatalogIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/publish': typeof AppPublishRoute
  '/tail': typeof AppTailRoute
  '/catalog/$stream': typeof AppCatalogStreamRoute
  '/catalog': typeof AppCatalogIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_app/publish': typeof AppPublishRoute
  '/_app/tail': typeof AppTailRoute
  '/_app/catalog/$stream': typeof AppCatalogStreamRoute
  '/_app/catalog/': typeof AppCatalogIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/publish' | '/tail' | '/catalog/$stream' | '/catalog/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/publish' | '/tail' | '/catalog/$stream' | '/catalog'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_app/publish'
    | '/_app/tail'
    | '/_app/catalog/$stream'
    | '/_app/catalog/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/publish': {
      id: '/_app/publish'
      path: '/publish'
      fullPath: '/publish'
      preLoaderRoute: typeof AppPublishRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tail': {
      id: '/_app/tail'
      path: '/tail'
      fullPath: '/tail'
      preLoaderRoute: typeof AppTailRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog/': {
      id: '/_app/catalog/'
      path: '/catalog'
      fullPath: '/catalog/'
      preLoaderRoute: typeof AppCatalogIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog/$stream': {
      id: '/_app/catalog/$stream'
      path: '/catalog/$stream'
      fullPath: '/catalog/$stream'
      preLoaderRoute: typeof AppCatalogStreamRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppPublishRoute: typeof AppPublishRoute
  AppTailRoute: typeof AppTailRoute
  AppCatalogStreamRoute: typeof AppCatalogStreamRoute
  AppCatalogIndexRoute: typeof AppCatalogIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppPublishRoute: AppPublishRoute,
  AppTailRoute: AppTailRoute,
  AppCatalogStreamRoute: AppCatalogStreamRoute,
  AppCatalogIndexRoute: AppCatalogIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
